import {useTheme} from 'contexts/ThemeContext';
import React from 'react';
import {Image, TouchableOpacity, View, Text} from 'react-native';
import styleSheet from './styles';

export interface CalendarDatePickerViewProps {
  onPress: () => void;
  title: string;
}

const CalendarDatePickerView = (props: CalendarDatePickerViewProps) => {
  const theme = useTheme();
  const styles = styleSheet(theme);

  return (
    <View style={styles.container}>
      <TouchableOpacity
        style={styles.touchableContainer}
        onPress={() => props.onPress()}>
        <Text style={styles.textStyle}>{props.title}</Text>
        <Image source={theme.images.smallArrowRight}></Image>
      </TouchableOpacity>
    </View>
  );
};

export default CalendarDatePickerView;
